import axios from 'axios'
import cache from './cache'
import Lockr from 'lockr'
import store from '@/store'

/** 移除授權資訊 */
export function removeAuth() {
  return new Promise((resolve, reject) => {
    cache.rmAxiosCache()
    store.commit('SET_ALLAUTH', null)
    delete axios.defaults.headers['authKey']
    delete axios.defaults.headers['sessionId']
    resolve(true)
  })
}

/** 注入授權資訊 */
export function addAuth(authKey, sessionId) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.authKey = authKey
    axios.defaults.headers.sessionId = sessionId
    resolve(true)
  })
}

/** 獲取授權資訊 */
export function getAuth() {
  /** 全域性路由觸發這個方法  如果有快取暫時在這裡交與 */
  if (Lockr.get('authKey') && !axios.defaults.headers.authKey) {
    cache.updateAxiosCache()
  }

  if (axios.defaults.headers.authKey || axios.defaults.headers.sessionId) {
    return true
  }
  return false
}
